'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _dec3, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactI18next = require('react-i18next');

var _reactBootstrap = require('react-bootstrap');

var _components = require('components');

var _reduxAsyncConnect = require('redux-async-connect');

var _reactRedux = require('react-redux');

var _language = require('redux/modules/language');

var languageActions = _interopRequireWildcard(_language);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isLoaded = languageActions.isLoaded,
    loadRecentWords = languageActions.loadRecentWords,
    loadRecentWords3 = languageActions.loadRecentWords3;
// const { loadLessonsWithFirstContent } = lessonActions;

var Knowledge = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: true,
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        _ref$params = _ref.params,
        page = _ref$params.page,
        language = _ref$params.language;

    // console.log("asyncConnect");
    if (!isLoaded(getState())) {
      // console.log("not in here?");
      return dispatch(loadRecentWords3(page, language));
    }
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    recentWords: state.language.data
    // lessons_first_content: state.lesson.lessons_first_content
  };
}, (0, _extends3.default)({}, languageActions)
// lessonActions
), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = function (_Component) {
  (0, _inherits3.default)(Knowledge, _Component);

  function Knowledge() {
    (0, _classCallCheck3.default)(this, Knowledge);
    return (0, _possibleConstructorReturn3.default)(this, (Knowledge.__proto__ || (0, _getPrototypeOf2.default)(Knowledge)).apply(this, arguments));
  }

  (0, _createClass3.default)(Knowledge, [{
    key: 'pushTranslation',
    value: function pushTranslation(word, lang) {

      return '/' + this.props.params.language + '/translate/' + encodeURIComponent(word) + '/' + lang; // replace 'en' code with another one.
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./Home.scss');
      var _props = this.props,
          t = _props.t,
          recentWords = _props.recentWords;


      var language = this.props.params.language === undefined ? 'en' : this.props.params.language;
      return _react2.default.createElement(
        'div',
        { className: styles.home },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _config2.default.is_for_personal_purpose && _react2.default.createElement(_components.SearchView, { onSubmit: function onSubmit(data) {
              data.language = data.language === undefined ? 'en' : data.language;
              _this2.props.history.push('/' + _this2.props.params.language + '/translate/' + encodeURIComponent(data.q) + '/' + data.language);
            } }),
          _config2.default.is_for_personal_purpose && _react2.default.createElement(
            _reactBootstrap.Button,
            { href: '/sentences/1', onClick: function onClick(e) {
                e.preventDefault();
                _this2.props.history.push('/sentences/1');
              } },
            t('content.see_sentences')
          ),
          recentWords !== undefined && recentWords.map(function (item, i) {
            return _react2.default.createElement(
              'div',
              null,
              (language === 'vi' && item.definition || language === 'en') && _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  _react2.default.createElement(
                    'b',
                    null,
                    item.word,
                    ' (',
                    item.lang,
                    ')'
                  )
                ),
                ' ',
                _react2.default.createElement(
                  'span',
                  null,
                  item.definition && _react2.default.createElement(
                    'span',
                    null,
                    ' ',
                    item.definition.map(function (data) {
                      var shortDefinition = data.definition + ' ' + (data.more_definition !== undefined ? data.more_definition : '');
                      var definition = shortDefinition.trim() !== '' ? shortDefinition.trim() : data.long_definition;
                      return _react2.default.createElement(
                        'span',
                        null,
                        ' ',
                        definition.substring(0, 200),
                        ' '
                      );
                    }),
                    ' '
                  ),
                  !item.definition && _react2.default.createElement(
                    'span',
                    null,
                    'No definitions'
                  )
                ),
                _react2.default.createElement(
                  _reactBootstrap.Button,
                  { href: _this2.pushTranslation(item.word, item.lang), bsStyle: 'link', onClick: function onClick(e) {
                      e.preventDefault();
                      _this2.props.history.push(_this2.pushTranslation(item.word, item.lang));
                    } },
                  'Xem...'
                ),
                _config2.default.is_for_personal_purpose && _react2.default.createElement(
                  _reactBootstrap.Button,
                  { href: '/newKnowledgeWithAShortSumary/' + item.lang + '/' + item.word, bsStyle: 'link', onClick: function onClick(e) {
                      e.preventDefault();
                      _this2.props.history.push('/newKnowledgeWithAShortSumary/' + item.lang + '/' + item.word);
                    } },
                  t('content.create_content_with_a_new_knowledge')
                )
              )
            );
          }),
          _react2.default.createElement('p', null),
          _react2.default.createElement(
            _reactBootstrap.Button,
            { href: '/' + language + '/knowledge/' + (parseInt(this.props.params.page) - 1 > 1 ? parseInt(this.props.params.page) - 1 : 1), onClick: function onClick(e) {
                // console.log("print me!")
                // console.log(`/knowledge/${this.props.params.page + 1}`)
                e.preventDefault();
                _this2.props.history.push('/' + language + '/knowledge/' + (parseInt(_this2.props.params.page) - 1 > 1 ? parseInt(_this2.props.params.page) - 1 : 1));
              } },
            ' Back '
          ),
          _react2.default.createElement(
            _reactBootstrap.Button,
            { href: '/' + language + '/knowledge/' + (parseInt(this.props.params.page) + 1), onClick: function onClick(e) {
                // console.log("print me!")
                // console.log(`/knowledge/${this.props.params.page + 1}`)
                e.preventDefault();
                _this2.props.history.push('/' + language + '/knowledge/' + (parseInt(_this2.props.params.page) + 1));
              } },
            'Next'
          )
        )
      );
    }
  }]);
  return Knowledge;
}(_react.Component)) || _class) || _class) || _class);
exports.default = Knowledge;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Language/Knowledge.js
// module id = 1532
// module chunks = 0